/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SystemHintsForStbGroupsResponse,
    SystemHintsForStbGroupsResponseFromJSON,
    SystemHintsForStbGroupsResponseToJSON,
} from '../models';

/**
 * 
 */
export class SystemHintsApi extends runtime.BaseAPI {

    /**
     * Read STB group system hints.
     */
    async readStbGroupSystemHintsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<SystemHintsForStbGroupsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/systemHints/stbGroups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SystemHintsForStbGroupsResponseFromJSON(jsonValue));
    }

    /**
     * Read STB group system hints.
     */
    async readStbGroupSystemHints(initOverrides?: RequestInit): Promise<SystemHintsForStbGroupsResponse> {
        const response = await this.readStbGroupSystemHintsRaw(initOverrides);
        return await response.value();
    }

}
